import * as React from 'react';
import PropTypes from 'prop-types';

import {
    Box,
    Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';

CommonSectionHeader.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string
};

export default function CommonSectionHeader({ title, titleStyle = {}, subTitle, subTitleStyle = {} }) {

    return (
        <Box>
            <Typography
                variant="subtitle1"
                sx={[
                    {
                        // color: 'primary.main',
                        // textTransform: 'uppercase',
                        // fontWeight: 800,
                        // fontSize: '1rem'
                    },
                    titleStyle,
                ]}
            >
                {title}
            </Typography>
            <Typography
                variant="subtitle2"
                sx={[
                    {
                        display: "block",
                        // color: 'secondary.main',
                        color: grey[700],
                        // fontWeight: 200,
                        // fontSize: '0.8rem'
                    },
                    subTitleStyle,
                ]}
            >
                {subTitle}
            </Typography>
        </Box>
    );
}